/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

document.addEventListener("DOMContentLoaded", function () {
    // Handle btn1
    var btn1 = document.querySelector(".btn1");
    if (btn1) {
        btn1.addEventListener("click", function () {
            window.open("https://picksticks.com/collections/yummy-picks-flavor-collection", "_blank");
        });

        if (window.location.href === "https://picksticks.com/collections/yummy-picks-flavor-collection") {
            btn1.disabled = true;
        }
    }

    // Handle btn
    var btn = document.querySelector(".btn");
    if (btn) {
        btn.addEventListener("click", function () {
            window.open("https://picksticks.com/collections/caffeine-toothpicks-collection", "_blank");
        });

        if (window.location.href === "https://picksticks.com/collections/caffeine-toothpicks-collection") {
            btn.disabled = true;
        }
    }
});
